import { isNil } from 'lodash'

const COPY_SUFFIX = ' (copy)'

export const duplicateToolName = (name, existingNames) => {
  const base = `${name}${COPY_SUFFIX}`
  if (!existingNames.includes(base)) {
    return base
  }
  let counter = 2
  while (existingNames.includes(`${name} (copy ${counter})`)) {
    counter += 1
  }
  return `${name} (copy ${counter})`
}

const promptToRequest = (prompt) =>
  isNil(prompt)
    ? null
    : {
        model: prompt.model ?? null,
        feature: prompt.feature,
        user_prompt: prompt.user_prompt,
        llm_model_id: prompt.llm_model_id ?? null,
        side: prompt.side,
        system_prompt: prompt.system_prompt ?? null,
        max_response_tokens: prompt.max_response_tokens,
        first_x_minutes: prompt.first_x_minutes ?? null,
        last_x_minutes: prompt.last_x_minutes ?? null,
      }

// The create request for a copy of `tool`: the stored record as is, minus the config version
// the API assigns, under a name no other tool of the organization uses.
export const buildDuplicateToolPayload = (tool, existingNames) => {
  const { version, ...config } = tool.config || {}

  return {
    name: duplicateToolName(tool.name, existingNames),
    type: tool.type,
    source: tool.source,
    prompt: promptToRequest(tool.prompt),
    eligibility_prompt: promptToRequest(tool.eligibility_prompt),
    user_whitelist: tool.user_whitelist,
    user_blacklist: tool.user_blacklist,
    playbook_whitelist: tool.playbook_whitelist,
    playbook_blacklist: tool.playbook_blacklist,
    allowed_urls: tool.allowed_urls,
    config: isNil(tool.config) ? null : config,
  }
}
